<template>
  <div class="page-container">
    <b-card no-body>
      <b-tabs pills card vertical>
        <b-tab title="Oczekujące" active class="p-0">
          <template slot="title"> <i data-feather="pause"></i> Oczekujące </template>
          <b-tabs content-class="mt-3" fill>
            <b-tab>
              <template slot="title"> <i data-feather="briefcase"></i> Organizacje </template>
            </b-tab>
            <b-tab active>
              <template slot="title">
                <i data-feather="users"></i> Niezależni konsultanci
                <b-badge>{{ preSurgeryConsultations.length }}</b-badge>
              </template>
              <div v-if="preSurgeryConsultations.length === 0" class="empty">Brak</div>
              <div class="list-container">
                <div
                  class="item card mb-2"
                  :class="{ visible: item.visible }"
                  v-bind:key="item.doctor.user_id"
                  v-for="item in preSurgeryConsultations"
                >
                  <div class="card-body row">
                    <div class="fullname col-7">
                      <i class="fas fa-user-md"></i> {{ item.doctor.title }} {{ item.doctor.name }}
                      {{ item.doctor.lastName }}
                    </div>
                    <div class="number-of-visits col-3">
                      <i class="fas fa-info-circle"></i> Ilość konsultacji: {{ item.visits.length }}
                    </div>
                    <b-button
                      v-show="!item.visible"
                      @click="item.visible = true"
                      variant="outline-primary"
                      class="col-2"
                      ><i class="fas fa-chevron-down"></i> Pokaż więcej</b-button
                    >
                    <b-button
                      v-show="item.visible"
                      @click="item.visible = false"
                      variant="primary"
                      class="col-2"
                      ><i class="fas fa-chevron-up"></i> Pokaż mniej</b-button
                    >
                    <div class="col-12 mt-4 visits-container">
                      <div class="title mb-0 pb-0">Kwalifikacje oczekujące na zabieg:</div>
                      <hr class="mt-2" />
                      <div
                        class="visit-container card bg-light mb-2"
                        v-bind:key="visit.IDRejestracja"
                        v-for="visit in item.visits"
                      >
                        <div class="card-body row">
                          <div class="visit-type col-6">
                            <i class="fas fa-eye"></i> {{ visit.visit_type }}
                          </div>
                          <div class="surgery-date col-4">
                            <i class="fas fa-calendar-week"></i> {{ visit.date }}
                          </div>
                          <div class="price col">
                            <i class="fas fa-tag"></i> {{ visit.price }}zł
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </b-tab>
        <b-tab title="Do rozliczenia" class="p-0">
          <template slot="title"> <i data-feather="inbox"></i> Do rozliczenia </template>
          <b-tabs content-class="mt-3" fill>
            <b-tab>
              <template slot="title"> <i data-feather="briefcase"></i> Organizacje </template>
            </b-tab>
            <b-tab active>
              <template slot="title">
                <i data-feather="users"></i> Niezależni konsultanci
                <b-badge>{{ unpaidConsultations.length }}</b-badge>
              </template>
              <div v-if="unpaidConsultations.length === 0" class="empty">Brak</div>
              <div class="list-container">
                <div
                  class="item card mb-2"
                  :class="{ visible: item.visible }"
                  v-bind:key="item.doctor.user_id"
                  v-for="item in unpaidConsultations"
                >
                  <div class="card-body row">
                    <div class="fullname col-7">
                      <i class="fas fa-user-md"></i> {{ item.doctor.title }} {{ item.doctor.name }}
                      {{ item.doctor.lastName }}
                    </div>
                    <div class="number-of-visits col-3">
                      <i class="fas fa-info-circle"></i> Ilość konsultacji: {{ item.visits.length }}
                    </div>
                    <b-button
                      v-show="!item.visible"
                      @click="item.visible = true"
                      variant="outline-primary"
                      class="col-2"
                      ><i class="fas fa-chevron-down"></i> Pokaż więcej</b-button
                    >
                    <b-button
                      v-show="item.visible"
                      @click="item.visible = false"
                      variant="primary"
                      class="col-2"
                      ><i class="fas fa-chevron-up"></i> Pokaż mniej</b-button
                    >
                    <div class="col-12 mt-4 visits-container">
                      <div class="title mb-0 pb-0">Kwalifikacje oczekujące na zabieg:</div>
                      <hr class="mt-2" />
                      <div
                        class="visit-container card bg-light mb-2"
                        v-bind:key="visit.IDRejestracja"
                        v-for="visit in item.visits"
                      >
                        <label
                          :for="`visit-${visit.IDRejestracja}`"
                          class="card-body row unpaid-card-body p-0 m-0"
                          :class="{ selected: visit.settle === 'true' }"
                        >
                          <b-form-checkbox
                            :id="`visit-${visit.IDRejestracja}`"
                            v-model="visit.settle"
                            name="`visit-${visit.IDRejestracja}`"
                            value="true"
                            unchecked-value="false"
                            class="checkbox-container col-1"
                          ></b-form-checkbox>
                          <div class="visit-type col-5">
                            <i class="fas fa-eye"></i> {{ visit.visit_type }} [{{
                              visit.IDRejestracja
                            }}]
                          </div>
                          <div class="surgery-date col-4">
                            <i class="fas fa-calendar-week"></i> {{ visit.date }}
                          </div>
                          <div class="price col">
                            <i class="fas fa-tag"></i> {{ visit.price }}zł
                          </div>
                        </label>
                      </div>
                      <b-button variant="secondary" class="float-right"
                        >Rozlicz zaznaczone</b-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </b-tab>
        <b-tab title="Rozliczone" class="p-0">
          <template slot="title"> <i data-feather="check"></i> Rozliczone </template>
          <b-tabs content-class="mt-3" fill>
            <b-tab>
              <template slot="title"> <i data-feather="briefcase"></i> Organizacje </template>
            </b-tab>
            <b-tab active>
              <template slot="title">
                <i data-feather="users"></i> Niezależni konsultanci
              </template>
              <div v-if="paidConsultations.length === 0" class="empty">Brak</div>
              <div class="list-container">
                <div
                  class="item card mb-2"
                  :class="{ visible: item.visible }"
                  v-bind:key="item.doctor.user_id"
                  v-for="item in paidConsultations"
                >
                  <div class="card-body row">
                    <div class="fullname col-7">
                      <i class="fas fa-user-md"></i> {{ item.doctor.title }} {{ item.doctor.name }}
                      {{ item.doctor.lastName }}
                    </div>
                    <div class="number-of-visits col-3">
                      <i class="fas fa-info-circle"></i> Ilość konsultacji: {{ item.visits.length }}
                    </div>
                    <b-button
                      v-show="!item.visible"
                      @click="item.visible = true"
                      variant="outline-primary"
                      class="col-2"
                      ><i class="fas fa-chevron-down"></i> Pokaż więcej</b-button
                    >
                    <b-button
                      v-show="item.visible"
                      @click="item.visible = false"
                      variant="primary"
                      class="col-2"
                      ><i class="fas fa-chevron-up"></i> Pokaż mniej</b-button
                    >
                    <div class="col-12 mt-4 visits-container">
                      <div class="title mb-0 pb-0">Kwalifikacje oczekujące na zabieg:</div>
                      <hr class="mt-2" />
                      <div
                        class="visit-container card bg-light mb-2"
                        v-bind:key="visit.IDRejestracja"
                        v-for="visit in item.visits"
                      >
                        <div class="card-body row">
                          <div class="visit-type col-6">
                            <i class="fas fa-eye"></i> {{ visit.visit_type }}
                          </div>
                          <div class="surgery-date col-4">
                            <i class="fas fa-calendar-week"></i> {{ visit.date }}
                          </div>
                          <div class="price col">
                            <i class="fas fa-tag"></i> {{ visit.price }}zł
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </b-tab>
          </b-tabs>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'Settlements',
  mounted() {
    const vm = this
    vm.fetchPreSurgeryConsultations()
    vm.fetchUnpaidConsultations()
    vm.fetchPaidConsultations()
  },
  data() {
    return {
      preSurgeryConsultations: [],
      unpaidConsultations: [],
      paidConsultations: []
    }
  },
  methods: {
    async fetchPreSurgeryConsultations() {
      const vm = this
      vm.preSurgeryConsultations = await vm.$http
        .post('e-zacma/sales-representative/get-pre-surgery-consultations')
        .then(response => response.data)
    },
    async fetchUnpaidConsultations() {
      const vm = this
      vm.unpaidConsultations = await vm.$http
        .post('e-zacma/sales-representative/get-unpaid-consultations')
        .then(response => response.data)
    },
    async fetchPaidConsultations() {
      const vm = this
      vm.paidConsultations = await vm.$http
        .post('e-zacma/sales-representative/get-paid-consultations')
        .then(response => response.data)
    }
  }
}
</script>

<style lang="scss">
.empty {
  text-align: center;
  font-size: 22px;
  line-height: 150px;
}

.list-container {
  padding: 10px;

  > .item {
    max-height: 100px;
    line-height: 60px;
    transition: 0.4s max-height ease-in-out;
    overflow: hidden;

    * {
      transition: 0.4s max-height ease-in-out;
    }

    &.visible {
      max-height: 400px;
    }
  }
}

.visits-container {
  max-height: 300px;
  overflow-y: scroll;
  overflow-x: hidden;

  .title {
    font-size: 17px;
    line-height: 17px;
  }

  .unpaid-card-body {
    cursor: pointer;
    box-sizing: content-box;
    border-radius: 3px;

    &.selected {
      border: 1px solid var(--primary);
    }

    .checkbox-container {
      box-sizing: content-box;
      text-align: center;

      .custom-control-label {
        margin-top: 17px;
        align-self: center;
        margin-bottom: 0;
      }
    }
  }
}
</style>
